<template>
  <div class="user-stock-page">
    <div class="toolbar">
      <el-input v-model="search.user_id" placeholder="用户ID" class="w120" />
      <el-input v-model="search.stock_code" placeholder="股票代码" class="w120" />
      <el-input v-model="search.stock_name" placeholder="股票名称" class="w120" />
      <el-button type="primary" @click="loadList">搜索</el-button>
    </div>
    <el-table
      ref="tableRef"
      :data="list"
      @selection-change="selChange"
      style="width:100%"
    >
      <el-table-column type="selection" width="40" />
      <el-table-column prop="user_id" label="用户" width="80" />
      <el-table-column prop="stock_code" label="股票代码" width="100" />
      <el-table-column prop="stock_name" label="股票名称" width="120" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="source" label="来源" width="100" />
      <el-table-column prop="status" label="状态" width="80" />
      <el-table-column prop="created_at" label="创建日期" width="100" />
      <el-table-column prop="updated_at" label="更新日期" width="100" />
      <el-table-column label="操作" width="160">
        <template #default="{row}">
          <el-button size="small" @click="edit(row)">更新</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      :current-page="pagination.page"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="prev, pager, next"
      @current-change="pageChange"/>
    <div class="batch-bar">
      <el-button @click="toggleAll">全选</el-button>
      <el-button type="danger" @click="batchRemove">批量删除</el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, shallowRef, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '@/utils/request'

const list = ref([])
const search = ref({ user_id: '', stock_code: '', stock_name: '' })
const pagination = ref({ page: 1, pageSize: 50, total: 0 })
const tableRef = shallowRef()
const selection = ref([])

const loadList = async () => {
  const params = { ...search.value, page: pagination.value.page, page_size: pagination.value.pageSize }
  try {
    const data = await request.get('/v1/admin-user-stock/list', { params })
    list.value = data.list || []
    pagination.value = data.pagination || pagination.value
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const pageChange = (p) => {
  pagination.value.page = p
  loadList()
}

const edit = (row) => {
  ElMessage.info('未实现: 更新')
}

const remove = async (row) => {
  try {
    await request.post('/v1/admin-user-stock/delete', { id: row.id })
    ElMessage.success('删除成功')
    loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const selChange = (val) => {
  selection.value = val
}

const toggleAll = () => {
  if (tableRef.value) tableRef.value.toggleAllSelection()
}

const batchRemove = async () => {
  const ids = selection.value.map(v => v.id)
  if (!ids.length) {
    ElMessage.warning('请选择要删除的记录')
    return
  }
  try {
    await request.post('/v1/admin-user-stock/batch-delete', { ids })
    ElMessage.success('删除成功')
    selection.value = []
    loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

onMounted(loadList)
</script>

<style scoped>
.toolbar { margin-bottom: 15px; display:flex; gap:10px; }
.w120 { width:120px; }
.pager { margin-top:15px; text-align:right; }
.batch-bar { margin-top:10px; display:flex; gap:10px; }
</style>
